// extracted by mini-css-extract-plugin
export default {"search":"Search_search__OSl1a","searchForm":"Search_searchForm__sN9lt","userChat":"Search_userChat__aBViU"};